import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { contentCountsRequest } from '../../app/actions/spaces/ContentCountsActions';
import { selectContentCounts, selectContentCountsUpToDate } from '../../app/selectors/ContentCountsSelector';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../app/selectors/SpaceInfoSelectors';
import { AppState } from '../../app/state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { LensSpace, LensSpaceDispatchProps, LensSpaceStateProps } from './LensSpace';

const mapStateToProps: MapStateToProps<LensSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  urls: siteUrlsSelector(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  contentCounts: selectContentCounts<'lens'>(state, 'lens'),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  siteUrlName: SessionSiteSelectors.siteUrlName(state),
});

const mapDispatchToProps: MapDispatchToProps<LensSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest,
  },
  dispatch);

export const ConnectedLensSpace = connect(mapStateToProps, mapDispatchToProps)(LensSpace);
